module.exports = __webpack_public_path__ + "img/abyss_fabric_logo_white.239a37c7.png";